// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  GenericApiResponseDict,
  GenericApiResponseMaintenanceEventApi,
  GenericApiResponseTenantPublicSettings,
  HTTPValidationError,
  MaintenanceEventApi,
} from '../../models';

/**
 * Reload tenant configurations from database.
Only accessible by admins.
 * @summary Reload Tenant Config
 */
export const reloadTenantConfig = (options?: AxiosRequestConfig): Promise<AxiosResponse<GenericApiResponseDict>> => {
  return axios.post(`/tenants/reload`, undefined, options);
};

export const getReloadTenantConfigMutationOptions = <
  TData = Awaited<ReturnType<typeof reloadTenantConfig>>,
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, void, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['reloadTenantConfig'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof reloadTenantConfig>>, void> = () => {
    return reloadTenantConfig(axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, void, TContext>;
};

export type ReloadTenantConfigMutationResult = NonNullable<Awaited<ReturnType<typeof reloadTenantConfig>>>;

export type ReloadTenantConfigMutationError = AxiosError<unknown>;

/**
 * @summary Reload Tenant Config
 */
export const useReloadTenantConfig = <
  TData = Awaited<ReturnType<typeof reloadTenantConfig>>,
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, void, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, void, TContext> => {
  const mutationOptions = getReloadTenantConfigMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Get public tenant settings based on hostname.
This endpoint should be polled periodically by the frontend to get:
- System messages
- Maintenance state
- Other tenant-wide updates
- Theme and branding information
- Login page customization
 * @summary Get Public Tenant Settings
 */
export const getPublicTenantSettings = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseTenantPublicSettings>> => {
  return axios.get(`/tenants/settings`, options);
};

export const getGetPublicTenantSettingsQueryKey = () => {
  return [`/tenants/settings`] as const;
};

export const getGetPublicTenantSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicTenantSettings>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTenantSettings>>, TError, TData>>;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPublicTenantSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicTenantSettings>>> = ({ signal }) =>
    getPublicTenantSettings({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicTenantSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPublicTenantSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicTenantSettings>>>;
export type GetPublicTenantSettingsQueryError = AxiosError<unknown>;

export function useGetPublicTenantSettings<
  TData = Awaited<ReturnType<typeof getPublicTenantSettings>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTenantSettings>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getPublicTenantSettings>>, TError, TData>, 'initialData'>;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPublicTenantSettings<
  TData = Awaited<ReturnType<typeof getPublicTenantSettings>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTenantSettings>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof getPublicTenantSettings>>, TError, TData>,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPublicTenantSettings<
  TData = Awaited<ReturnType<typeof getPublicTenantSettings>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTenantSettings>>, TError, TData>>;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Public Tenant Settings
 */

export function useGetPublicTenantSettings<
  TData = Awaited<ReturnType<typeof getPublicTenantSettings>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTenantSettings>>, TError, TData>>;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPublicTenantSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a new maintenance event.
Only accessible by admins.
 * @summary Add Maintenance Event
 */
export const addMaintenanceEvent = (
  maintenanceEventApi: MaintenanceEventApi,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseMaintenanceEventApi>> => {
  return axios.post(`/tenants/maintenance`, maintenanceEventApi, options);
};

export const getAddMaintenanceEventMutationOptions = <
  TData = Awaited<ReturnType<typeof addMaintenanceEvent>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: MaintenanceEventApi }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['addMaintenanceEvent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof addMaintenanceEvent>>, { data: MaintenanceEventApi }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return addMaintenanceEvent(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: MaintenanceEventApi },
    TContext
  >;
};

export type AddMaintenanceEventMutationResult = NonNullable<Awaited<ReturnType<typeof addMaintenanceEvent>>>;
export type AddMaintenanceEventMutationBody = MaintenanceEventApi;
export type AddMaintenanceEventMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Add Maintenance Event
 */
export const useAddMaintenanceEvent = <
  TData = Awaited<ReturnType<typeof addMaintenanceEvent>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: MaintenanceEventApi }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: MaintenanceEventApi }, TContext> => {
  const mutationOptions = getAddMaintenanceEventMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete a maintenance event by its created_at timestamp.
Only accessible by admins.
 * @summary Delete Maintenance Event
 */
export const deleteMaintenanceEvent = (
  eventCreatedAt: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseDict>> => {
  return axios.delete(`/tenants/maintenance/${eventCreatedAt}`, options);
};

export const getDeleteMaintenanceEventMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteMaintenanceEvent>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { eventCreatedAt: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['deleteMaintenanceEvent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMaintenanceEvent>>, { eventCreatedAt: string }> = (
    props,
  ) => {
    const { eventCreatedAt } = props ?? {};

    return deleteMaintenanceEvent(eventCreatedAt, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { eventCreatedAt: string }, TContext>;
};

export type DeleteMaintenanceEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMaintenanceEvent>>>;

export type DeleteMaintenanceEventMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Delete Maintenance Event
 */
export const useDeleteMaintenanceEvent = <
  TData = Awaited<ReturnType<typeof deleteMaintenanceEvent>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { eventCreatedAt: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { eventCreatedAt: string }, TContext> => {
  const mutationOptions = getDeleteMaintenanceEventMutationOptions(options);

  return useMutation(mutationOptions);
};
